var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColumnChartStacked(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1.458c6.335 0 9.042 2.707 9.042 9.042v7c0 6.335-2.707 9.042-9.042 9.042h-7c-6.335 0-9.042-2.707-9.042-9.042v-7c0-6.335 2.707-9.042 9.042-9.042h7z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFCFC",
    x: 7,
    y: 14,
    width: 3.5,
    height: 8.167,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFCFC",
    x: 12.833,
    y: 16.333,
    width: 3.5,
    height: 5.833,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFCFC",
    x: 12.833,
    y: 5.833,
    width: 3.5,
    height: 9.333,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFCFC",
    x: 18.667,
    y: 5.833,
    width: 3.5,
    height: 5.833,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFCFC",
    x: 7,
    y: 5.833,
    width: 3.5,
    height: 7,
    rx: 1.75
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#FFFCFC",
    x: 18.667,
    y: 12.833,
    width: 3.5,
    height: 9.333,
    rx: 1.75
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnChartStacked);
export default __webpack_public_path__ + "static/media/column-chart-stacked.cd0279efdb6a55b7f7d113a27097fa35.svg";
export { ForwardRef as ReactComponent };